import React from 'react';
import { Instagram, Facebook, MessageCircle, MapPin, Mail, Phone, Clock } from 'lucide-react';

const GOLD = '#C9A84C';

const LOGO_URL =
  'https://customer-assets-rejwkqb3.emergentagent.net/job_6105b58a-7e55-474e-a974-617e58e42c4a/artifacts/q23o4nye_Gemini_Generated_Image_487caf487caf487c.png';

const TikTokIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.76a4.85 4.85 0 0 1-1.01-.07z"/>
  </svg>
);

export default function Contact() {
  const socialChannels = [
    {
      icon: MessageCircle,
      platform: 'WhatsApp',
      handle: '+52 (663) 699 5409',
      description: 'Escríbenos directamente para hacer tu pedido o resolver cualquier duda.',
      action: 'Abrir WhatsApp',
      href: 'https://wa.me/526636995409',
      color: '#25D366',
      bg: 'rgba(37,211,102,0.06)',
      border: 'rgba(37,211,102,0.2)',
    },
    {
      icon: Instagram,
      platform: 'Instagram',
      handle: '@aurachocolatesmx',
      description: 'Síguenos para ver los últimos contenidos, testimonios y novedades de la marca.',
      action: 'Seguir en Instagram',
      href: 'https://www.instagram.com/aurachocolatesmx/',
      color: '#E1306C',
      bg: 'rgba(225,48,108,0.06)',
      border: 'rgba(225,48,108,0.2)',
    },
    {
      icon: Facebook,
      platform: 'Facebook',
      handle: 'Aurachocolatesmx',
      description: 'Únete a nuestra comunidad, comparte tu experiencia y mantente informado.',
      action: 'Visitar Facebook',
      href: 'https://facebook.com/Aurachocolatesmx',
      color: '#1877F2',
      bg: 'rgba(24,119,242,0.06)',
      border: 'rgba(24,119,242,0.2)',
    },
    {
      icon: TikTokIcon,
      platform: 'TikTok',
      handle: '@aurachocolatesmx',
      description: 'Mira nuestros videos, recetas y experiencias con Aura Chocolate Supreme.',
      action: 'Ver en TikTok',
      href: 'https://www.tiktok.com/@aurachocolatesmx',
      color: '#ffffff',
      bg: 'rgba(255,255,255,0.05)',
      border: 'rgba(255,255,255,0.15)',
    },
  ];

  const contactInfo = [
    { icon: MapPin, label: 'Distribución', value: 'República Mexicana' },
    { icon: Mail, label: 'Correo', value: 'contacto@aurachocolates.com.mx' },
    { icon: Clock, label: 'Atención', value: 'Lunes a Viernes · 9:00 - 18:00 hrs' },
    { icon: Phone, label: 'WhatsApp', value: '+52 (663) 699 5409' },
  ];

  return (
    <main style={{ background: '#0A0A0A', color: '#fff', fontFamily: 'Montserrat, sans-serif' }}>
      {/* PAGE HERO */}
      <section
        style={{
          position: 'relative',
          padding: '10rem 1.5rem 5rem',
          background: '#0A0A0A',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'radial-gradient(ellipse at 50% 0%, rgba(201,168,76,0.06) 0%, transparent 60%)',
            pointerEvents: 'none',
          }}
        />
        <div style={{ maxWidth: '48rem', margin: '0 auto', textAlign: 'center' }}>
          <img
            src={LOGO_URL}
            alt="Aura Logo"
            style={{ width: '5rem', height: '5rem', borderRadius: '50%', objectFit: 'cover', marginBottom: '2rem' }}
          />
          <p
            style={{ color: GOLD, fontSize: '0.68rem', letterSpacing: '0.4em', textTransform: 'uppercase', marginBottom: '1rem' }}
          >
            Aura King & Queen
          </p>
          <h1
            style={{
              fontFamily: 'Cormorant Garamond, serif',
              fontSize: 'clamp(2.8rem, 5vw, 4.5rem)',
              fontWeight: 300,
              color: '#fff',
              marginBottom: '1.5rem',
              lineHeight: 1.1,
            }}
          >
            Contáctanos
          </h1>
          <p
            style={{
              fontSize: '0.85rem',
              lineHeight: 1.85,
              color: 'rgba(255,255,255,0.5)',
              maxWidth: '32rem',
              margin: '0 auto',
            }}
          >
            Estamos aquí para ayudarte. Encuéntranos en nuestras redes sociales o escríbenos directamente.
          </p>
        </div>
      </section>

      {/* SOCIAL MEDIA CHANNELS */}
      <section style={{ padding: '4rem 1.5rem 6rem', background: '#070707' }}>
        <div style={{ maxWidth: '64rem', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
            <p style={{ color: GOLD, fontSize: '0.68rem', letterSpacing: '0.4em', textTransform: 'uppercase', marginBottom: '0.75rem' }}>
              Redes Sociales
            </p>
            <h2
              style={{
                fontFamily: 'Cormorant Garamond, serif',
                fontSize: 'clamp(2rem, 3.5vw, 2.8rem)',
                fontWeight: 300,
                color: '#fff',
              }}
            >
              Encuéntranos en{' '}
              <span style={{ color: GOLD, fontStyle: 'italic' }}>Todas las Plataformas</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4" style={{ gap: '1.5rem' }}>
            {socialChannels.map((ch) => {
              const Icon = ch.icon;
              return (
                <div
                  key={ch.platform}
                  style={{
                    background: '#111111',
                    border: `1px solid ${ch.border}`,
                    padding: '2.5rem 2rem',
                    textAlign: 'center',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = `0 20px 40px rgba(0,0,0,0.4), 0 0 30px ${ch.bg}`;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <div
                    style={{
                      width: '4rem',
                      height: '4rem',
                      borderRadius: '50%',
                      background: ch.bg,
                      border: `1px solid ${ch.border}`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 1.5rem',
                    }}
                  >
                    <Icon size={24} style={{ color: ch.color }} />
                  </div>
                  <h3
                    style={{
                      fontFamily: 'Cormorant Garamond, serif',
                      fontSize: '1.5rem',
                      fontWeight: 400,
                      color: '#fff',
                      marginBottom: '0.5rem',
                    }}
                  >
                    {ch.platform}
                  </h3>
                  <p
                    style={{
                      color: ch.color,
                      fontSize: '0.78rem',
                      fontWeight: 500,
                      marginBottom: '1rem',
                      letterSpacing: '0.05em',
                    }}
                  >
                    {ch.handle}
                  </p>
                  <p
                    style={{
                      color: 'rgba(255,255,255,0.45)',
                      fontSize: '0.78rem',
                      lineHeight: 1.75,
                      marginBottom: '2rem',
                    }}
                  >
                    {ch.description}
                  </p>
                  <a
                    href={ch.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-block',
                      padding: '0.75rem 1.75rem',
                      background: 'transparent',
                      border: `1px solid ${ch.border}`,
                      color: ch.color,
                      fontSize: '0.68rem',
                      letterSpacing: '0.15em',
                      textTransform: 'uppercase',
                      fontWeight: 600,
                      textDecoration: 'none',
                      transition: 'background 0.3s ease',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = ch.bg)}
                    onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
                  >
                    {ch.action}
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CONTACT INFO */}
      <section style={{ padding: '5rem 1.5rem' }}>
        <div style={{ maxWidth: '48rem', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <p style={{ color: GOLD, fontSize: '0.68rem', letterSpacing: '0.4em', textTransform: 'uppercase', marginBottom: '0.75rem' }}>
              Información
            </p>
            <h2
              style={{
                fontFamily: 'Cormorant Garamond, serif',
                fontSize: 'clamp(2rem, 3.5vw, 2.8rem)',
                fontWeight: 300,
                color: '#fff',
              }}
            >
              Datos de{' '}
              <span style={{ color: GOLD, fontStyle: 'italic' }}>Contacto</span>
            </h2>
          </div>

          <div style={{ background: '#111111', border: '1px solid rgba(201,168,76,0.15)' }}>
            {contactInfo.map(({ icon: Icon, label, value }, i) => (
              <div
                key={i}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1.5rem',
                  padding: '1.25rem 2rem',
                  borderBottom: i < contactInfo.length - 1 ? '1px solid rgba(201,168,76,0.08)' : 'none',
                }}
              >
                <div
                  style={{
                    width: '2.5rem',
                    height: '2.5rem',
                    borderRadius: '50%',
                    background: 'rgba(201,168,76,0.08)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <Icon size={15} style={{ color: GOLD }} />
                </div>
                <div>
                  <div style={{ color: 'rgba(201,168,76,0.7)', fontSize: '0.6rem', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: '0.2rem' }}>
                    {label}
                  </div>
                  <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.85rem' }}>{value}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* BOTTOM NOTE */}
      <section
        style={{
          padding: '4rem 1.5rem',
          textAlign: 'center',
          background: '#060606',
          borderTop: '1px solid rgba(201,168,76,0.1)',
        }}
      >
        <div style={{ maxWidth: '30rem', margin: '0 auto' }}>
          <p
            style={{
              fontFamily: 'Cormorant Garamond, serif',
              fontSize: '1.4rem',
              fontWeight: 300,
              fontStyle: 'italic',
              color: 'rgba(255,255,255,0.6)',
              lineHeight: 1.7,
            }}
          >
            "El tiempo de respuesta es de{' '}
            <span style={{ color: GOLD }}>24 horas hábiles</span>.
            Estamos felices de atenderte."
          </p>
        </div>
      </section>
    </main>
  );
}
